import { isMailConnectedForPopup, onMailSuiteAuthenticated } from "./suiteAuthBoot";

/** Slug popup auth.app — doit exister dans HUB_AUTH_REDIRECT_APP_NAMES (hub). */
export const MAIL_AUTH_REDIRECT_SLUG = "mail";

type SessionLostHandler = () => void;

export function installMailAuthPopup(onSessionLost: SessionLostHandler): void {
  if (typeof window.installSuiteAuthPopup !== "function") {
    console.error("Email : kit suite-shared introuvable (installSuiteAuthPopup)");
    return;
  }

  window.installSuiteAuthPopup({
    redirect: MAIL_AUTH_REDIRECT_SLUG,
    isConnected: isMailConnectedForPopup,
    onAuthenticated: async (userId: number) => {
      await onMailSuiteAuthenticated(userId);
    },
    onSessionLost: onSessionLost,
    patchFetch: false,
  });
}

declare global {
  interface Window {
    installSuiteAuthPopup?: (opts: {
      redirect?: string;
      isConnected?: () => boolean;
      onAuthenticated?: (userId: number) => void | Promise<void>;
      onSessionLost?: () => void;
      patchFetch?: boolean;
    }) => void;
    __suiteOnManualConnectClick?: () => void;
  }
}
